import React, { useRef, useEffect, useState } from "react";
import "./HighlightsStyle.css";
import qimamImg    from "../images/qimam.jpeg";
import samsungImg  from "../images/Samsung inovation campus.png";
import appleImg    from "../images/apple academy.png";

const highlights = [
  {
    id: 1,
    badgeColor: "#F59E0B",
    org: "McKinsey & Company",
    title: "Qimam Fellowship '26",
    description:
      "Selected among the top 50 students from over 18,000 applicants nationwide to participate in Saudi Arabia's premier leadership fellowship. The program included executive mentoring, leadership & strategy workshops, one-on-one mentorship with C-level executives, and visits to leading public and private sector organizations.",
    image: qimamImg,
    accent: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
    tag: "Leadership · Strategy · Executive Mentoring",
  },
  {
    id: 2,
    badgeColor: "#1D4ED8",
    org: "Samsung Innovation Campus × Misk Foundation",
    title: "AI Program Graduate",
    description:
      "Completed the prestigious Samsung Innovation Campus Artificial Intelligence Program, delivered in partnership with the Misk Foundation. Advanced hands-on training in AI, Machine Learning, Deep Learning, and Computer Vision, culminating in the development of real-world AI applications.",
    image: samsungImg,
    accent: "linear-gradient(135deg, #1D4ED8 0%, #1E40AF 100%)",
    tag: "AI · ML · Deep Learning · Computer Vision",
  },
  {
    id: 3,
    badgeColor: "#6D28D9",
    org: "Apple Developer Academy × Tuwaiq Academy",
    title: "Foundation Program Graduate",
    description:
      "Successfully completed the Apple Foundation Program — an immersive program by the Apple Developer Academy. Gained hands-on experience in Swift, SwiftUI, iOS Development, Design Thinking, UI/UX, and AI integration, culminating in a production-ready AI-powered iOS application.",
    image: appleImg,
    accent: "linear-gradient(135deg, #6D28D9 0%, #4C1D95 100%)",
    tag: "Swift · SwiftUI · iOS · Design Thinking",
  },
];

function HighlightCard({ item, index }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`hl-card ${visible ? "hl-card--visible" : ""}`}
      style={{ "--delay": `${index * 0.15}s`, "--accent": item.badgeColor }}
    >
      {/* Glowing border top */}
      <div className="hl-card__glow-bar" style={{ background: item.accent }} />

      {/* Image */}
      <div className="hl-card__img-wrap">
        <img src={item.image} alt={item.title} className="hl-card__img" />
        <div className="hl-card__img-overlay" style={{ background: `${item.badgeColor}22` }} />
      </div>

      {/* Body */}
      <div className="hl-card__body">
        <div className="hl-card__org">{item.org}</div>
        <h3 className="hl-card__title">{item.title}</h3>
        <p className="hl-card__desc">{item.description}</p>

        {/* Tech tag row */}
        <div className="hl-card__tag" style={{ borderColor: `${item.badgeColor}44`, color: item.badgeColor }}>
          {item.tag}
        </div>
      </div>

      {/* Corner number */}
      <div className="hl-card__num">0{item.id}</div>
    </div>
  );
}

export default function Highlights({ id }) {
  return (
    <section className="hl-section" id={id}>
      {/* Section header */}
      <div className="hl-header">
        <span className="hl-header__eyebrow">Featured</span>
        <h2 className="hl-header__title">Highlights</h2>
        <p className="hl-header__sub">
          Milestones that define the journey
        </p>
      </div>

      {/* Cards grid */}
      <div className="hl-grid">
        {highlights.map((item, i) => (
          <HighlightCard key={item.id} item={item} index={i} />
        ))}
      </div>
    </section>
  );
}
